import { render, staticRenderFns } from "./WBotsCode.vue?vue&type=template&id=5894db3e&"
import script from "./WBotsCode.vue?vue&type=script&lang=js&"
export * from "./WBotsCode.vue?vue&type=script&lang=js&"
import style0 from "./WBotsCode.vue?vue&type=style&index=0&id=5894db3e&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports